export default __webpack_public_path__ + "static/media/2.ef11ea52.png";